import type { FieldDefinition, FieldOption, FilterGroup, SortSpec } from '@/tableControls'
import { filterRows, matchTerm } from '@/tableControls'

export function distinctFieldOptions(
  values: string[],
  labelFn: (value: string) => string = (value) => value,
): FieldOption[] {
  return [...new Set(values.filter(Boolean))]
    .sort((a, b) => a.localeCompare(b))
    .map((value) => ({ value, label: labelFn(value) }))
}

export function filterRowsWithTree<T>(
  rows: T[],
  filterTree: FilterGroup | null,
  fields: FieldDefinition[],
): T[] {
  return filterRows(rows, filterTree, fields, (row, fieldKey) => {
    const field = fields.find((entry) => entry.key === fieldKey)
    if (field?.accessor) {
      return field.accessor(row)
    }
    return (row as Record<string, unknown>)[fieldKey]
  })
}

export function filterRowsByText<T>(
  rows: T[],
  query: string,
  getSearchText: (row: T) => string,
): T[] {
  const trimmed = query.trim()
  if (!trimmed) return rows
  return rows.filter((row) => matchTerm(getSearchText(row), trimmed))
}

export function toggleSingleColumnSort(prev: SortSpec[], field: string): SortSpec[] {
  const existing = prev.find((entry) => entry.field === field)
  if (existing) {
    return [{ field, direction: existing.direction === 'asc' ? 'desc' : 'asc' }]
  }
  return [{ field, direction: 'asc' }]
}
